













































































































































































































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import SelectEntity from "@/components/form/SelectEntity.vue";
import moment from "moment";
import {
  ContractEdit as IContractEdit,
  ContractEditTypeEnum as EContractEditTypeEnum
} from "@/api/models/contract-edit";
import { Contract as IContract } from "@/api/models/contract";
import { ContractShort as IContractShort } from "@/api/models/contract-short";
import api, { agentApi } from "@/getinfo-api";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import OrderItemPreview from "@/components/orders/OrderItemPreview.vue";
import employee, { EmployeeListParams } from "@/getinfo-api/employee";
import { Employee as IEmployee } from "@/api/models/employee";
import { EmployeesList2 as IEmployeesList2 } from "@/api/models/employees-list2";
import { getCurrentCompanyId, getCurrentUserId, isRoot } from "@/plugins/roles";
import EditorWithFile from "@/components/EditorWithFile.vue";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";
import LearningResources from "@/components/contract/LearningResources.vue";
import ContractFormLearningResourceTableItem from "@/components/contract/ContractFormLearningResourceTableItem.vue";
import ContractFormLearningResourceTable from "@/components/contract/ContractFormLearningResourceTable.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import LearningRequest from "@/components/contract/LearningRequest.vue";
import CPageButtons from "@/components/form/CustomPage/CPageButtons.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import CField from "@/components/form/CField.vue";
import { ContractorsListClass } from "@/classes/list/ContractorsListClass";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import { LearningResourceInfo as ILearningResourceInfo } from "@/api/models/learning-resource-info";
import { ContractsListClass } from "@/classes/list/ContractsListClass";
import DocumentNumberInput from "@/components/form/DocumentNumberInput.vue";
import { nextSequence } from "@/utils/generate-helper";
import { AgentListClass } from "@/classes/list/AgentListClass";
import { ConditionsListClass } from "@/classes/list/ConditionsListClass";
import { agentsModule } from "@/plugins/modules-detect";
import { Agent as IAgent } from "@/api-v2/agent/models/agent";
import ConditionForm from "@/components/condition/ConditionForm.vue";
import { Condition as ICondition } from "@/api-v2/agent/models";

@Component({
  components: {
    ConditionForm,
    DocumentNumberInput,
    CSingleSelect,
    CField,
    CBlock,
    CPageButtons,
    LearningRequest,
    CustomButton,
    ContractFormLearningResourceTable,
    ContractFormLearningResourceTableItem,
    LearningResources,
    EditorWithFile,
    SelectEntity,
    OrderItemPreview,
    CustomDatepicker
  }
})
export default class ContractForm extends Vue {
  @Prop() contract?: IContract;
  @Prop({ default: false }) isNewWindowOnSave?: boolean;
  @Prop({ default: () => [] }) importedLearningResources?: Array<
    ILearningResourceInfo
  >;
  @Prop() propContractorType!: string;
  @Prop() propContractorId!: string;
  withOutNDS: boolean = true;
  nds: number = 20;
  contractType!: "contract" | "annex" | undefined;
  companyId!: string;
  //todo fix type
  contractorType: string = "physical";
  contractorId?: string;
  number!: string;
  responsibleId!: string | undefined; // Менеджер заявки
  paymentConditions: string = "Полная предоплата";
  comment: string = "";
  signedAt!: Date | undefined;
  formedAt!: Date | undefined;
  agentId!: string | undefined;
  paymentConditionsSelect: string = "Полная предоплата";
  userCustomPaymentCondition!: string;
  limit: number = 30;
  offset: number = 0;
  learningRequestCount: number = 0;
  showSpinner: boolean = false;
  disabledContractorType: boolean = false;
  userIds: Array<string> = [];
  documentsManagers!: Array<IEmployee>;
  learningResources: Array<ILearningResourceInfo> | undefined = [];
  showAddLearningResource: boolean = false;
  showAddLearningRequest: boolean = false;
  isContractCreating: boolean = false;
  isContractRemoving: boolean = false;
  contractorList: ContractorsListClass = new ContractorsListClass({
    type: this.contractorType,
    companyId: this.selectedCompany
  });
  conditionId: string | undefined;
  isOpenConditionForm: boolean = false;
  isLoadingCondition: boolean = false;
  agentList: AgentListClass = new AgentListClass();
  conditionList: ConditionsListClass = new ConditionsListClass();

  contractList: ContractsListClass = new ContractsListClass(
    {
      type: "contract"
    },
    // @ts-ignore
    this.contract?.type === "annex" ? this.contract?.contract.id : undefined
  );
  contractId!: string;

  data() {
    return {
      contractType: "contract",
      companyId: undefined,
      contractorId: undefined,
      number: undefined, //номер договора
      responsibleId: undefined,
      signedAt: undefined,
      formedAt: undefined,
      userCustomPaymentCondition: undefined,
      searchRequestByTitle: undefined,
      documentsManagers: undefined,
      contractId: undefined,
      conditionId: undefined,
      agentId: undefined
    };
  }

  get contractOrAnnex() {
    return EContractEditTypeEnum;
  }

  get root() {
    return isRoot();
  }

  get companyOwner() {
    return this.$store.getters.userIsCompanyOwner;
  }

  get userId() {
    return getCurrentUserId();
  }

  get selectedCompany() {
    return getCurrentCompanyId();
  }

  get isAgentModuleEnabled() {
    return agentsModule();
  }

  getContract() {
    if (this.contract) {
      this.contract.contractor && this.contract.contractor.type
        ? (this.contractorType = this.contract.contractor?.type)
        : undefined;
      this.contract.contractor && this.contract.contractor.id
        ? (this.contractorId = this.contract.contractor.id)
        : undefined;
      this.signedAt = this.contract.signedAt;
      this.formedAt = this.contract.formedAt;
      this.number = this.contract.number;
      this.responsibleId = this.contract.responsibleId;
      this.agentId = this.contract.agentId;
      this.conditionId = this.contract?.conditionId ?? undefined;
      this.getPaymentConditionsProp();
      this.learningResources = this.contract.learningResources;
      if (this.contract.comment) this.comment = this.contract.comment;
      if (this.contract.nds || this.contract.nds === 0) {
        this.nds = this.contract.nds;
        this.withOutNDS = false;
      } else {
        this.withOutNDS = true;
      }
      this.contractType = this.contract.type as
        | "contract"
        | "annex"
        | undefined;
      // @ts-ignore
      this.contractId = this.contract?.contract?.id ?? undefined;
    }
  }

  async createCondition(condition: ICondition) {
    try {
      this.isLoadingCondition = true;
      const { data } = await agentApi.Condition.createCondition(condition);
      this.conditionList = new ConditionsListClass();
      this.conditionId = data.id;
      this.isOpenConditionForm = false;
      await this.$store.dispatch("successToast", {
        message: this.$tc(this.$translate.Successful)
      });
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.isLoadingCondition = false;
    }
  }

  getPaymentConditionsProp() {
    if (this.contract) {
      if (
        this.contract.paymentConditions === "Полная предоплата" ||
        this.contract.paymentConditions === "Предоплата 50%" ||
        this.contract.paymentConditions === "Полная постоплата"
      ) {
        this.paymentConditionsSelect = this.contract.paymentConditions;
      } else {
        this.paymentConditionsSelect = "Ввести вручную";
        this.userCustomPaymentCondition = this.contract.paymentConditions;
      }
    }
  }

  getLimited(item: any) {
    return `${this.$tc(
      this.$translate.Contract
    )} №${this.$converter.limitedOutput(item.number, 20)} от ${moment(
      item.createdAt
    ).format("ll")}`;
  }

  getDocumentsManager() {
    const compId = localStorage.getItem("selectedCompany");
    if (compId) {
      let params: EmployeeListParams = {
        id: compId,
        roles: ["document_manager"]
      };
      employee(params).then((res: { data: IEmployeesList2 }) => {
        this.documentsManagers = res.data.employees;
        if (this.root || this.companyOwner) {
          this.responsibleId = res.data.employees[0]?.id;
          if (this.contract) {
            this.responsibleId = this.contract.responsibleId;
          }
        } else {
          res.data.employees?.forEach(el => {
            if (el.user.id === this.userId) this.responsibleId = el.id;
          });
        }
      });
    }
  }

  selectContractorId(item: any) {
    if (!this.contract) {
      if (item && item.id) {
        this.contractorId = item.id;
      }
    }
  }

  getContractLearningResource(item: any) {
    this.learningResources?.push(item);
    this.showAddLearningResource = false;
  }

  removeLearningResource(index: number) {
    this.learningResources?.splice(index, 1);
  }

  removeContract() {
    if (this.contract) {
      this.isContractCreating = true;
      api.ContractApi._delete(this.contract.id)
        .then(() => {
          this.$router.push({
            name: "contracts"
          });
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        })
        .finally(() => {
          this.isContractCreating = false;
        });
    }
  }

  setCondition(agent: IAgent) {
    if (!this.contract) {
      this.conditionId = agent.conditionId;
    }
  }

  createContract() {
    let usersIds: Array<string> = [];
    this.learningResources?.forEach(el => {
      el.userIds?.forEach(userId => {
        usersIds.push(userId);
      });
    });
    this.userIds = Array.from(new Set(usersIds));

    let contractCreateParams: IContractEdit = {
      companyId: this.selectedCompany,
      // @ts-ignore
      contractId: this.contractType === "annex" ? this.contractId : undefined,
      contractorId: this.contractorId,
      number: this.number,
      userIds: this.userIds ? this.userIds : [],
      responsibleId: this.responsibleId,
      learningResources: this.learningResources
        ? this.learningResources
        : undefined,
      paymentConditions: this.paymentConditions,
      comment: this.comment,
      signedAt: this.signedAt,
      formedAt: this.formedAt ?? new Date(),
      agentId: this.agentId,
      nds: !this.withOutNDS ? this.nds : undefined,
      conditionId: this.conditionId,
      type:
        this.contractType === "contract"
          ? this.contractOrAnnex.Contract
          : this.contractOrAnnex.Annex
    };
    api.ContractApi.create(contractCreateParams)
      .then(async (res: { data: IContract }) => {
        await nextSequence();
        if (this.isNewWindowOnSave) {
          let routeData = this.$router.resolve({
            name: "contractItem",
            params: { contractId: res.data.id }
          });
          await window.open(routeData.href, "_blank");
          this.$emit("saveContract", res.data);
        } else {
          await this.$router.push({
            name: "contractItem",
            params: {
              contractId: res.data.id
            }
          });
        }
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => {
        this.isContractCreating = false;
      });
  }

  async contractActionHandler() {
    if (await this.$store.dispatch("validate/CHECK_VALIDATIONS")) return;

    this.isContractCreating = true;
    if (!this.contract) {
      this.createContract();
    } else {
      // edit
      let usersIds: Array<string> = [];
      this.learningResources?.forEach(el => {
        el.userIds?.forEach(userId => {
          usersIds.push(userId);
        });
      });
      this.userIds = Array.from(new Set(usersIds));
      let contractEditParams: IContractEdit = {
        companyId: this.contract.companyId,
        contractorId: this.contractorId,
        number: this.number,
        responsibleId: this.responsibleId,
        contractId: this.contractType === "annex" ? this.contractId : undefined,
        userIds: this.userIds,
        learningResources: this.learningResources,
        paymentConditions: this.paymentConditions,
        comment: this.comment,
        agentId: this.agentId,
        conditionId: this.conditionId,
        signedAt: this.signedAt,
        formedAt: this.formedAt ?? new Date(),
        nds: !this.withOutNDS ? this.nds : undefined,
        // @ts-ignore
        type: this.contractType,
        fileIds: this.contract.files
          ? this.contract.files.map((el: any) => el.id)
          : []
      };
      api.ContractApi.edit(this.contract.id, contractEditParams)
        .then(async (res: { data: IContract }) => {
          await nextSequence();
          await this.$router.push({
            name: "contractItem",
            params: {
              contractId: res.data.id
            }
          });
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        })
        .finally(() => {
          this.isContractCreating = false;
        });
    }
  }

  checkClientType() {
    //@ts-ignore
    this.contractorList.params.type = !this.contractorType
      ? undefined
      : this.contractorType;
    this.contractorList.params.offset = 0;
    this.contractorList.listItems = [];
    this.contractorList.list();
  }

  @Watch("contractorType")
  loadType() {
    this.checkClientType();
    this.disabledContractorType = true;
    setTimeout(() => {
      this.disabledContractorType = false;
    }, 1500);
  }

  @Watch("contractorId")
  updateLearningRequestsByContractorId() {
    this.offset = 0;
    this.learningRequestCount = 0;
  }

  @Watch("paymentConditionsSelect")
  paymentMethod() {
    if (this.paymentConditionsSelect !== "Ввести вручную") {
      this.paymentConditions = this.paymentConditionsSelect;
    } else {
      this.paymentConditions = this.userCustomPaymentCondition;
    }
  }

  @Watch("importedLearningResources", { immediate: true })
  checkImportedLearningResources() {
    if (this.importedLearningResources?.length && this.learningResources) {
      this.learningResources = [
        ...this.learningResources,
        ...this.importedLearningResources
      ];
    }
  }

  @Watch("userCustomPaymentCondition")
  updateCustomPayment() {
    this.paymentConditions = this.userCustomPaymentCondition;
  }

  @Watch("selectedCompany")
  updateEntity() {
    if (!this.contract) {
      this.responsibleId = undefined;
      this.getDocumentsManager();
    }
  }

  async checkContractIdInRoute() {
    if (
      (this.$route.query?.contractId || this.$route.params.contractId) &&
      !this.contract
    ) {
      this.contractId =
        (this.$route.query!.contractId as string) ||
        (this.$route.params.contractId as string);
      this.contractList = new ContractsListClass(
        {
          type: "contract"
        },
        this.contractId
      );
      this.contractType = "annex";

      try {
        const { data } = await api.ContractApi.get(this.contractId);
        this.contractorId = data.contractor?.id;
        this.contractorType = data.contractor?.type!;
        this.responsibleId = data.responsibleId;
        this.agentId = data.agentId;
        this.conditionId = data.conditionId;
        this.contractId = data.id;
      } catch (e) {
        throw new Error(e as any);
      }
    }
  }

  getSelectedContract(contract: IContractShort) {
    if (!this.contract) {
      contract?.contractor && contract?.contractor.contractorType
        ? (this.contractorType = contract.contractor?.contractorType)
        : undefined;
      contract?.contractor
        ? (this.contractorId = contract.contractor.id)
        : undefined;

      this.contractorType = contract?.contractor?.contractorType!;
      this.contractorId = contract?.contractor?.id;
      this.responsibleId = contract?.responsible?.id;
    }

    if (!this.contract && Number.isInteger(contract.nds)) {
      this.nds = contract.nds!;
      this.withOutNDS = false;
    }
  }

  async created() {
    this.formedAt = new Date();
    if (this.propContractorType) {
      this.contractorType = this.propContractorType;
    }
    if (this.propContractorId) {
      this.contractorId = this.propContractorId;
    }
    await this.getDocumentsManager();
    await this.checkContractIdInRoute();
    await this.getContract();
  }
}
